// extracted by mini-css-extract-plugin
export default {"notFoundWrapper":"notFound_notFoundWrapper__Gk6Ob","img":"notFound_img__gQy-k","link":"notFound_link__vKyeb"};